import { render, staticRenderFns } from "./promotion-sidebar-icons.vue?vue&type=template&id=ce009ac8"
import script from "./promotion-sidebar-icons.vue?vue&type=script&lang=js"
export * from "./promotion-sidebar-icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports